var render = function render(_c,_vm){return _c('SfIcon',{attrs:{"icon":_vm.injections.imports.icons[_vm.props.icon].path,"view-box":_vm.injections.imports.icons[_vm.props.icon].viewBox}})
}
var staticRenderFns = []

export { render, staticRenderFns }